import React, { SyntheticEvent, useState } from 'react';
import { Button, Checkbox, FormField, Header, Icon, Message, Modal, ModalActions, ModalContent, Popup } from 'semantic-ui-react';

interface QuoteSentModalProps {
    prospectAppointmentId: string;
    onSubmit: (event: SyntheticEvent, prospectAppointmentId: string | undefined) => void;
}

const QuoteSentModal = ({
    prospectAppointmentId, onSubmit
}: QuoteSentModalProps) => {

    const [openModal, setOpenModal] = useState(false);
    const [quoteSent, setQuoteSent] = useState(false);

    const handleOpenModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    return (
        <Modal
            closeOnDimmerClick
            closeIcon={true}
            size="small"
            onClose={(event) => handleCancelModal(event)}
            open={openModal}
            trigger={
                <Popup
                    trigger={
                        <Button color="black" icon size="mini" onClick={(event) => handleOpenModal(event)}>
                            <Icon name="send" />
                        </Button>
                    }
                    content='Marcar cotización enviada'
                    position='top center'
                    size='small'
                    inverted
                />
            } >
            <Header icon="send" content="Cotización enviada" />
            <ModalContent>
                <Message
                    warning
                    icon="warning"
                    content="Asegurate de que la cotizacion ya ha sido enviada. Esta accion no se puede deshacer."
                />

                <div className="ui form">
                    <FormField>
                        <Checkbox
                            label="Confirmo que la cotizacion ya ha sido enviada."
                            checked={quoteSent}
                            onChange={(event, data) => setQuoteSent(quoteSent ? false : true)}
                        />
                    </FormField>
                </div>
            </ModalContent>
            <ModalActions>
                <Button onClick={(event) => handleCancelModal(event)}>
                    <Icon name="cancel" /> Cancelar
                </Button>
                <Button color="green" onClick={(event) => onSubmit(event, prospectAppointmentId)} disabled={!quoteSent}>
                    <Icon name="checkmark" /> Aceptar
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default QuoteSentModal;
